import { render, staticRenderFns } from "./RemoveBadgeDialog.vue?vue&type=template&id=1602b252&scoped=true"
import script from "./RemoveBadgeDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveBadgeDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RemoveBadgeDialog.vue?vue&type=style&index=0&id=1602b252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1602b252",
  null
  
)

export default component.exports